export default __webpack_public_path__ + "static/media/img5.deb6aade.jpg";